import React from 'react';
import {
  Box,
  Button,
  Flex,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
} from '@chakra-ui/react';
import { Question } from 'phosphor-react';
import { KanbanSelo } from '../../../../components/kanban/CardPadrao';
import { FLUXO_META, FLUXO_ORDEM, RISCO_META, NivelRisco } from '../legalizacaoPlaybook';
import { FLUXO_ICON } from './FluxoIcons';

// Semáforo de risco — MESMA fonte do selo de prazo e da faixa do card (RISCO_META), não
// uma cópia. Legenda que diverge do que a tela mostra é pior que legenda nenhuma.
const RISCO_ITENS: { nivel: NivelRisco; texto: string }[] = [
  { nivel: 0, texto: 'dentro do prazo' },
  { nivel: 1, texto: 'perto do prazo' },
  { nivel: 2, texto: 'no limite (ainda no prazo)' },
  { nivel: 3, texto: 'fora do prazo (SLA)' },
];

/**
 * Legenda do board — em POPOVER, não em faixa fixa.
 *
 * 2026-08-11: era uma faixa permanente com 9 itens a 11px acima do board. Legenda é
 * material de REFERÊNCIA: consulta-se uma vez e depois nunca mais. Ocupar uma faixa
 * inteira pra sempre, num board que já tem 4 bandas de moldura antes do primeiro card,
 * custa caro — ainda mais porque os elementos que ela explica (badge de risco, ícones de
 * fluxo) já têm tooltip próprio.
 *
 * Quem está aprendendo abre; quem já sabe recupera a faixa.
 */
export const LegalizacaoLegenda: React.FC = () => (
  <Popover placement="bottom-start" trigger="click" isLazy>
    <PopoverTrigger>
      <Button
        size="sm"
        variant="ghost"
        color="gray.500"
        fontWeight="500"
        fontSize="13px"
        leftIcon={<Question size={14} weight="bold" />}
        aria-label="Abrir a legenda do board"
      >
        Legenda
      </Button>
    </PopoverTrigger>
    <PopoverContent w="320px" borderColor="gray.200" boxShadow="0 8px 28px rgba(15,23,42,.14)">
      <PopoverArrow />
      <PopoverBody px={4} py={3.5}>
        <Text
          fontSize="10px"
          fontWeight="700"
          color="gray.400"
          textTransform="uppercase"
          letterSpacing="0.08em"
          mb={2}
        >
          Risco do card
        </Text>
        <Flex direction="column" gap={1.5} mb={3.5}>
          {RISCO_ITENS.map(item => (
            <Flex key={item.texto} align="center" gap={2}>
              <KanbanSelo
                ponto
                cor={RISCO_META[item.nivel].seloCor}
                bg={RISCO_META[item.nivel].seloBg}
              >
                {RISCO_META[item.nivel].rotulo}
              </KanbanSelo>
              <Text fontSize="11px" color="gray.600">
                {item.texto}
              </Text>
            </Flex>
          ))}
          <Flex align="center" gap={2}>
            <KanbanSelo cor="gray.600" bg="gray.100">
              Sem prazo
            </KanbanSelo>
            <Text fontSize="11px" color="gray.600">
              fora do termômetro
            </Text>
          </Flex>
          <Text fontSize="11px" color="gray.500" mt={0.5}>
            A faixa colorida à esquerda do card aparece em Atenção, Crítico e Atrasado. Na última
            coluna, a faixa verde é o processo pronto para finalizar.
          </Text>
        </Flex>

        <Box h="1px" bg="gray.100" mb={3.5} />

        <Text
          fontSize="10px"
          fontWeight="700"
          color="gray.400"
          textTransform="uppercase"
          letterSpacing="0.08em"
          mb={2}
        >
          Marcadores da etapa
        </Text>
        <Flex direction="column" gap={1.5}>
          {FLUXO_ORDEM.map(m => {
            const IconComp = FLUXO_ICON[m];
            const meta = FLUXO_META[m];
            return (
              <Flex key={m} align="center" gap={2}>
                <Flex
                  w="18px"
                  h="18px"
                  borderRadius="md"
                  align="center"
                  justify="center"
                  bg="gray.100"
                  color="gray.500"
                  flexShrink={0}
                >
                  <IconComp size={11} weight="bold" />
                </Flex>
                <Text fontSize="11px" color="gray.600">
                  {meta.label}
                  <Text as="span" color="gray.400">
                    {' '}
                    — {meta.descricao}
                  </Text>
                </Text>
              </Flex>
            );
          })}
        </Flex>
      </PopoverBody>
    </PopoverContent>
  </Popover>
);
